import { combineReducers, Reducer } from 'redux';
import { RouterState } from 'redux-first-history';
import { announcementsReducer } from 'src/modules/announcements/reducers/announcementsReducer';
import { assetReducer } from 'src/modules/asset/reducers/assetReducer';
import { carbonIntensityReducer } from 'src/modules/carbon-intensity/reducers/carbonIntensityReducer';
import { configReducer } from 'src/modules/config/reducers/configReducer';
import { evaluationReducer } from 'src/modules/evaluation/reducers/evaluationReducer';
import { feedbackReducer } from 'src/modules/feedback/reducers/feedbackReducer';
import { loginReducer } from 'src/modules/login/reducers/loginReducer';
import { modalStackReducer } from 'src/modules/modals/reducers/modalStackReducer';
import { notificationReducer } from 'src/modules/notifications/reducers/notificationReducer';
import { organizationReducer } from 'src/modules/organization/reducers/organizationReducer';
import { partnerDashboardReducer } from 'src/modules/partner-dashboard/reducers/partnerDashboardReducer';
import { passwordResetReducer } from 'src/modules/password-reset/reducers/passwordResetReducer';
import { profileReducer } from 'src/modules/profile/reducers/profileReducer';
import { projectListReducer } from 'src/modules/project-list/reducers/projectListReducer';
import { projectSyncReducer } from 'src/modules/project-sync/reducers/projectSyncReducer';
import { projectViewReducer } from 'src/modules/project-view/reducers/projectViewReducer';
import { reportReducer } from 'src/modules/report/reducers/reportReducer';
import { routingReducer } from 'src/modules/routing/reducers/routingReducer';
import { saveProjectReducer } from 'src/modules/save-project/SaveProjectReducer';
import { scrollReducer } from 'src/modules/scroll/reducers/scrollReducer';
import { shareProjectReducer } from 'src/modules/sharing-projects/reducers/shareProjectReducer';
import { usersReducer } from 'src/modules/users/reducers/usersReducer';
import { RootState } from 'src/types/RootState';

export const rootReducer = (
  router: Reducer<RouterState>,
): Reducer<RootState> => combineReducers<RootState>({
  router: router,
  routing: routingReducer,

  scroll: scrollReducer,

  config: configReducer,
  login: loginReducer,
  asset: assetReducer,
  report: reportReducer,
  saveProject: saveProjectReducer,
  modals: modalStackReducer,
  feedback: feedbackReducer,
  evaluation: evaluationReducer,

  projectList: projectListReducer,
  projectView: projectViewReducer,
  projectSync: projectSyncReducer,
  notification: notificationReducer,
  announcements: announcementsReducer,
  carbonIntensity: carbonIntensityReducer,

  profile: profileReducer,
  users: usersReducer,
  organization: organizationReducer,
  shareProject: shareProjectReducer,
  passwordReset: passwordResetReducer,
  partnerDashboard: partnerDashboardReducer,
});
